import { useEffect } from 'react';
import { PAMainCard } from '../../components/PlanConfig/MainCard';
import WaitingStep from '../../components/PlanConfig/WaitingStep';
import WaitingCard from '../../components/WaitingCard';
import { useGetHubResume } from '../../hooks/ScheduleHub/useGetHubResume';
import ScheduleHub from '../ScheduleHub';

const LoadingHub = () => {
  const { isError: isErrorResumo, refetch } = useGetHubResume();

  useEffect(() => {
    if (!isErrorResumo) return;

    const intervalId = setInterval(() => {
      console.error(
        'PlanoAdaptativo não foi localizado no PLANO_ADAPTATIVO_API'
      );
      refetch();
    }, 5000);

    return () => clearInterval(intervalId);
  }, [refetch, isErrorResumo]);

  return (
    <PAMainCard background={''}>{isErrorResumo ? <WaitingCard /> : <ScheduleHub />}</PAMainCard>
  );
};

export default LoadingHub;
